import React, { Component } from 'react';
import Counter from '../components/counter';
import globalizacao from '../escolha/globalizacao';

class HomeNumbers extends Component {
    render() {
        return (
            <section className="secao nossos-numeros fundo-white">
                <div className="limite conteudo">
                    <h2>{globalizacao.msg("nossosNumeros")}</h2>
                    <p dangerouslySetInnerHTML={{ __html: globalizacao.msg("nossosNumerosTexto") }}>

                    </p>

                    <ul className="lista lista-numbers">
                        <li>
                            <div className="contador">
                                +<Counter total={30000000} />
                            </div>
                            {globalizacao.msg("milhoesDownload")}
                        </li>
                        <li>
                            <div className="contador">
                                +<Counter total={110} />
                            </div>
                            {globalizacao.msg("totalPais")}
                        </li>


                    </ul>


                </div>
                <div className="fundo-opacidade"></div>
            </section>

        );
    }
}

export default HomeNumbers;



// WEBPACK FOOTER //
// ./src/js/pages/home-numbers.js